import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SharedDepositField = _resolveComponent("SharedDepositField")!
  const _component_UIButton = _resolveComponent("UIButton")!
  const _component_SharedWindow = _resolveComponent("SharedWindow")!

  return (_openBlock(), _createBlock(_component_SharedWindow, {
    class: _normalizeClass(_ctx.b()),
    onClose: _ctx.handleClose
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.b('content'))
      }, [
        _createElementVNode("h1", {
          class: _normalizeClass(_ctx.b('title'))
        }, _toDisplayString(_ctx.$t("Ввод")), 3),
        _createElementVNode("h4", {
          class: _normalizeClass(_ctx.b('sub-title'))
        }, _toDisplayString(_ctx.$t("Отправьте")) + " " + _toDisplayString(_ctx.displayedAmount) + " " + _toDisplayString(_ctx.displayedDeposit.currencyName.toUpperCase()) + " " + _toDisplayString(_ctx.$t("по этим реквизитам:")), 3),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.b('form'))
        }, [
          _createVNode(_component_SharedDepositField, {
            label: 
            _ctx.$t('Полное фирменное наименование Общества на официальном языке')
          ,
            value: _ctx.requisites.org_full_name_local
          }, null, 8, ["label", "value"]),
          _createVNode(_component_SharedDepositField, {
            label: 
            _ctx.$t('Полное фирменное наименование Общества на английском языке')
          ,
            value: _ctx.requisites.org_full_name_eng
          }, null, 8, ["label", "value"]),
          _createVNode(_component_SharedDepositField, {
            label: _ctx.$t('ИНН'),
            value: _ctx.requisites.inn
          }, null, 8, ["label", "value"]),
          _createVNode(_component_SharedDepositField, {
            label: _ctx.$t('Код VO (Код Валютной операции)'),
            value: _ctx.requisites.payment_code_name
          }, null, 8, ["label", "value"]),
          _createVNode(_component_SharedDepositField, {
            label: _ctx.$t('Назначение платежа'),
            value: _ctx.displayedPayment
          }, null, 8, ["label", "value"])
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.b('tabs'))
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.requisites.mex_requisite_banks, (bank) => {
            return (_openBlock(), _createElementBlock("button", {
              class: _normalizeClass(_ctx.b('tab', { active: bank.id === _ctx.bankId })),
              key: bank.id,
              onClick: ($event: any) => (_ctx.handleBank(bank.id))
            }, _toDisplayString(_ctx.handleBankLabel(bank.recipient_bank)), 11, _hoisted_1))
          }), 128))
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.b('form'))
        }, [
          _createVNode(_component_SharedDepositField, {
            label: _ctx.$t('БАНК получателя'),
            value: _ctx.displayedBank.recipient_bank
          }, null, 8, ["label", "value"]),
          _createVNode(_component_SharedDepositField, {
            label: _ctx.$t('Р/с №'),
            value: _ctx.displayedBank.current_account
          }, null, 8, ["label", "value"]),
          _createVNode(_component_SharedDepositField, {
            label: _ctx.$t('ИНН'),
            value: _ctx.displayedBank.current_inn
          }, null, 8, ["label", "value"]),
          _createVNode(_component_SharedDepositField, {
            label: _ctx.$t('Корр. счет'),
            value: _ctx.displayedBank.recipient_correspondent_account
          }, null, 8, ["label", "value"]),
          _createVNode(_component_SharedDepositField, {
            label: _ctx.$t('SWIFT/БИК'),
            value: _ctx.displayedBank.recipient_correspondent_swift
          }, null, 8, ["label", "value"]),
          _hoisted_2,
          _createVNode(_component_SharedDepositField, {
            label: _ctx.$t('БАНК-корреспондент'),
            value: _ctx.displayedBank.correspondent_bank
          }, null, 8, ["label", "value"]),
          _createVNode(_component_SharedDepositField, {
            label: _ctx.$t('SWIFT/БИК'),
            value: _ctx.displayedBank.bic
          }, null, 8, ["label", "value"]),
          _createVNode(_component_SharedDepositField, {
            label: _ctx.$t('ИНН'),
            value: _ctx.displayedBank.inn
          }, null, 8, ["label", "value"]),
          _createVNode(_component_SharedDepositField, {
            label: _ctx.$t('Корр. счет'),
            value: _ctx.displayedBank.correspondent_account
          }, null, 8, ["label", "value"])
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.b('footer'))
        }, [
          _createElementVNode("p", {
            class: _normalizeClass(_ctx.b('footer-label'))
          }, [
            _createTextVNode(_toDisplayString(_ctx.$t(
              "Нажимая кнопку, вы подтверждаете факт отправки средств на указанный адрес."
            )) + " ", 1),
            _createElementVNode("br", {
              class: _normalizeClass(_ctx.b('footer-br'))
            }, null, 2),
            _createTextVNode(" " + _toDisplayString(_ctx.$t("Ваш баланс обновится после зачисления средств на ваш счет")), 1)
          ], 2),
          _createVNode(_component_UIButton, {
            class: _normalizeClass(_ctx.b('footer-confirm')),
            view: "main",
            label: _ctx.$t('Подтвердить отправление'),
            disabled: _ctx.isDisabled,
            onClick: _ctx.handleConfirm
          }, null, 8, ["class", "label", "disabled", "onClick"])
        ], 2)
      ], 2)
    ]),
    _: 1
  }, 8, ["class", "onClose"]))
}